module.exports = __webpack_public_path__ + "media/images/pic/anime/party-3476c26c9b18ec2a8d795b80faebd06a.svg";